import OfflineEventRegistration from './OfflineEventRegistration';
import OnlineEventRegistration from './OnlineEventRegistration';

import { isMoreOrLessThanCurrent } from 'utils/dates';

import { useBroadcastsStatus } from 'hooks/utils/useBroadcastsStatus';

import { BroadcastType } from 'graphql/types';

import css from './Registration.module.scss';

//Если количество занятых мест больше или равно 70% от общего числа доступных мест к регистрации, тогда отображаем блок с ползунком и количеством мест
export const isMoreAvailableSeats = ({
  capacity,
  left,
}: {
  capacity: number;
  left: number;
}): boolean => {
  if (!capacity || !left) return true;
  const employedPlaces: number = capacity - left;
  const percent: number = 0.7;
  return employedPlaces >= Math.floor(capacity * percent);
};

export interface IRegistrationProps {
  eventId?: string;
  isOffline?: boolean;
  isUserRegistered?: boolean;
  isRegistrationOff: boolean;
  left: number;
  capacity: number;
  startDate: string;
  finishDate: string;
  enrollFinishDate: string;
  broadcasts: BroadcastType[];

  onSignUpClick(): void;
  onCancel(): void;
}

export default function Registration(props: IRegistrationProps) {
  const {
    isOffline,
    startDate,
    isRegistrationOff,
    finishDate,
    enrollFinishDate,
    broadcasts,
  } = props;

  const { currentBroadcast } = useBroadcastsStatus(broadcasts);
  const isRegistrationOver = isMoreOrLessThanCurrent(enrollFinishDate);
  const isEventStarted = isMoreOrLessThanCurrent(startDate);
  const isEventFinished = isMoreOrLessThanCurrent(finishDate);

  //  определяет условия отображения блока с информацией о регистрации на онлайн/оффлан мероприятия,
  const isEventRegistrationShown = () => {
    // для оффлайн мероприятия
    if (isOffline) {
      // отображаем, если  регистрация на мероприятие еще не закончилась, или регистрация выключена
      if (isRegistrationOff) {
        return false;
      } else {
        return !isRegistrationOver;
      }
    }

    // для онлайн мероприятия
    if (!isOffline) {
      //  отображем, если регистрация выключена, и нет трансляции в эфире
      if (isRegistrationOff && !currentBroadcast) {
        return false;
      } else {
        // инчаче, отображаем, если мероприятие еще не началось, или
        // в промежуток между трансляциями
        if (!isEventStarted || (!isEventFinished && !currentBroadcast)) {
          return true;
        }
      }
    }

    return false;
  };

  return isEventRegistrationShown() ? (
    <div className={css.container}>
      <div id="event_registration" className={css.block}>
        {isOffline ? (
          <OfflineEventRegistration {...props} />
        ) : (
          <OnlineEventRegistration {...props} isEventStarted={isEventStarted} />
        )}
      </div>
    </div>
  ) : null;
}
